import axios from 'axios';
import { utilityService } from '@/services/utilityService.js';

function __getDataCollectionStats (depth) {
    return axios.get(utilityService.getApiUrl('report/stats/office/depth/' + depth),
        // Third parameter is the configuration object
        {
            headers: utilityService.getHeaders()
        }
    );
}

function __getTest (depth) {
    return axios.get(utilityService.getApiUrl('report/stats/office/depth/' + depth),
        // Third parameter is the configuration object
        {
            headers: utilityService.getHeaders()
        }
    );
}

function __getDataCollectionStatsReportForOffice (officeId) {
    return axios.get(utilityService.getApiUrl('report/stats/office/' + officeId),
        // Third parameter is the configuration object
        {
            headers: utilityService.getHeaders()
        }
    );
}

function __getOfficeListAtDepthForReport (depth, reportType) {
    return axios.get(utilityService.getApiUrl('report/stats/' + reportType + '/office/depth/' + depth),
        // Third parameter is the configuration object
        {
            headers: utilityService.getHeaders()
        }
    );
}

function __getOfficeListAtIdForReport (id, reportType) {
    return axios.get(utilityService.getApiUrl('report/stats/' + reportType + '/office/' + id),
        // Third parameter is the configuration object
        {
            headers: utilityService.getHeaders()
        }
    );
}

function __getProgressReport () {
	return axios.get(utilityService.getApiUrl('report/progressreport'),
			// Third parameter is the configuration object
			{
					headers: utilityService.getHeaders()
			}
	);
}

function __getSubOfficeProgressReport (survetId, searchValue) {
	return axios.get(utilityService.getApiUrl('report/progresssubreport/' + survetId + '/office/' + searchValue),
			// Third parameter is the configuration object
			{
					headers: utilityService.getHeaders()
			}
	);
}

function __getDataCollectionStatsForReport (reportType) {
    return axios.get(utilityService.getApiUrl('report/agencylist/' + reportType),
        // Third parameter is the configuration object
        {
            headers: utilityService.getHeaders()
        }
    );
}

function __getDataCollectionStatsReportForSuboffices (officeId, statusId) {
    return axios.get(utilityService.getApiUrl('report/subofficelist/' + officeId + '/' + statusId),
        // Third parameter is the configuration object
        {
            headers: utilityService.getHeaders()
        }
    );
}

function __getSurveyRootFromId (surveyId) {
	return axios.get(utilityService.getApiUrl('report/surveyroot/' + surveyId),
			// Third parameter is the configuration object
			{
					headers: utilityService.getHeaders()
			}
	);
}

function __getOfficeFromId (officeId) {
	return axios.get(utilityService.getApiUrl('report/office/' + officeId),
			// Third parameter is the configuration object
			{
					headers: utilityService.getHeaders()
			}
	);
}

export const adminDataCollectionService = {
    getDataCollectionStats: (depth) => __getDataCollectionStats(depth),
    getDataCollectionStats1: (depth) => __getTest(depth),
	getDataCollectionStatsForOffice: (officeId) => __getDataCollectionStatsReportForOffice(officeId),
	getOfficeListAtDepthForReport: (depth, reportType) => __getOfficeListAtDepthForReport(depth, reportType),
	getOfficeListAtIdForReport: (id, reportType) => __getOfficeListAtIdForReport(id, reportType),
    getDataCollectionStatsForReport: (reportType) => __getDataCollectionStatsForReport(reportType),
    getDataCollectionStatsReportForOffice: (officeId) => __getDataCollectionStatsReportForOffice(officeId),
	getDataCollectionStatsReportForSuboffices: (officeId, statusId) => __getDataCollectionStatsReportForSuboffices(officeId, statusId),
	// getAgencyProgressReport: () => __getAgencyProgressReport(),
	getProgressReport: () => __getProgressReport(),
	getSurveyRootFromId: (surveyId) => __getSurveyRootFromId(surveyId),
	getOfficeFromId: (officeId) => __getOfficeFromId(officeId),
	getSubOfficeProgressReport: (survetId, searchValue) => __getSubOfficeProgressReport(survetId, searchValue)
};
